var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlertInterconsult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFEFEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3411_287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4254 29.175C10.0421 29.175 9.75039 29.0083 9.55039 28.675C9.35039 28.3417 9.35039 28.0083 9.55039 27.675L19.1504 11.15C19.3337 10.8 19.6171 10.625 20.0004 10.625C20.3837 10.625 20.6671 10.8 20.8504 11.15L30.4504 27.675C30.6504 28.0083 30.6504 28.3417 30.4504 28.675C30.2504 29.0083 29.9587 29.175 29.5754 29.175H10.4254ZM20.1004 17.825C19.8837 17.825 19.7046 17.8958 19.5629 18.0375C19.4212 18.1792 19.3504 18.3583 19.3504 18.575V22.55C19.3504 22.7667 19.4212 22.9458 19.5629 23.0875C19.7046 23.2292 19.8837 23.3 20.1004 23.3C20.3171 23.3 20.4962 23.2292 20.6379 23.0875C20.7796 22.9458 20.8504 22.7667 20.8504 22.55V18.575C20.8504 18.3583 20.7796 18.1792 20.6379 18.0375C20.4962 17.8958 20.3171 17.825 20.1004 17.825ZM20.1004 26.05C20.3171 26.05 20.5046 25.9708 20.6629 25.8125C20.8212 25.6542 20.9004 25.4583 20.9004 25.225C20.9004 25.0083 20.8212 24.825 20.6629 24.675C20.5046 24.525 20.3171 24.45 20.1004 24.45C19.8837 24.45 19.6962 24.5292 19.5379 24.6875C19.3796 24.8458 19.3004 25.0333 19.3004 25.25C19.3004 25.4667 19.3796 25.6542 19.5379 25.8125C19.6962 25.9708 19.8837 26.05 20.1004 26.05Z",
    fill: "#FE632F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3411_287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertInterconsult);
export default __webpack_public_path__ + "static/media/iconAlertInterconsult.8ea8adfb84f3c447bf4c141ec9d33718.svg";
export { ForwardRef as ReactComponent };